import type { SVGProps, ReactNode } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export function SvgPhoneIdentification({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): ReactNode {
  return (
    <svg
      aria-labelledby={titleId}
      fill="none"
      height={200}
      viewBox="0 0 200 200"
      width={200}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M77.686 172.756a3.03 3.03 0 0 1-1.407-2.624V58.635a8.63 8.63 0 0 1 3.878-7.238l44.166-24.805c1.444-.817 1.256-.36 3.308 1.106 2.053 1.465 1.784 3.309 1.784 4.412l.037 109.253a8.75 8.75 0 0 1-3.955 7.357L82.64 173.405a4.2 4.2 0 0 1-1.99.393c-1.304 0-2.165-.531-2.964-1.042"
        fill="#fff"
      />
      <path
        d="m77.686 172.756.135-.211zm-1.407-2.624h.25v.005zm0-111.497.25-.001zm3.878-7.238-.138-.209.015-.01zm44.166-24.805.123.218h-.001zm5.092 5.518h-.25zm.037 109.253-.25.002v-.001zm-3.955 7.357.137.209-.013.008zM82.64 173.405l.125.217-.018.009zm-1.99.393v-.251l.013.001zm-3.099-.831a3.3 3.3 0 0 1-1.133-1.217l.441-.236c.226.421.556.772.962 1.031zm-1.133-1.217a3.3 3.3 0 0 1-.389-1.623l.5.01a2.8 2.8 0 0 0 .33 1.377zm-.389-1.618V58.635h.5v111.497zm0-111.496a8.9 8.9 0 0 1 1.053-4.228l.441.236a8.4 8.4 0 0 0-.994 3.99zm1.053-4.228a8.9 8.9 0 0 1 2.937-3.22l.275.417a8.4 8.4 0 0 0-2.771 3.04zm2.952-3.23L124.2 26.375l.245.436-44.166 24.805zM124.2 26.376c.36-.204.648-.346.905-.405.278-.062.513-.026.756.095.224.113.461.301.748.532.293.236.661.536 1.168.897l-.291.407c-.519-.37-.898-.678-1.191-.914-.3-.242-.492-.391-.658-.474a.57.57 0 0 0-.421-.055c-.178.04-.409.147-.77.352zm5.465 5.735.037 109.253-.5.001-.037-109.254zm.037 109.252a9 9 0 0 1-1.073 4.3l-.44-.237a8.5 8.5 0 0 0 1.013-4.06zm-1.073 4.3a9 9 0 0 1-2.995 3.267l-.274-.418a8.5 8.5 0 0 0 2.829-3.086zm-3.008 3.275-42.856 24.685-.25-.434 42.857-24.685zm-42.874 24.694a4.4 4.4 0 0 1-2.11.416l.026-.499a3.95 3.95 0 0 0 1.87-.369zm-2.097.417c-1.382 0-2.296-.568-3.099-1.081l.27-.422c.795.509 1.603 1.003 2.83 1.003zm47.127-146.554c1.077.77 1.556 1.65 1.759 2.487.198.82.129 1.605.129 2.129h-.5c0-.579.065-1.268-.115-2.011-.176-.727-.589-1.501-1.564-2.198z"
        fill="#1D1D1B"
      />
      <path
        d="M74.085 53.19a8.73 8.73 0 0 1 2.904-3.175l42.844-24.693.123-.065.065-.041c2.097-.831 5.44.913 7.267 2.245-1.154-.617-2.166-.864-3.704-.006l-42.84 24.702a8.89 8.89 0 0 0-4 7.463l.069 110.62a3.3 3.3 0 0 0 .409 1.635c.265.5.656.922 1.133 1.226.958.578 2.1.77 3.194.54-3.738 1.532-8.061-.961-8.315-5.084a3 3 0 0 1-.057-.593l-.131-110.58a8.75 8.75 0 0 1 1.039-4.193Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="m72.26 68.482-.001-.025V66.79c0-.315.14-.586.416-.702.26-.109.564-.048.837.115a2.005 2.005 0 0 1 .994 1.592v1.663c0 .31-.13.585-.407.703-.259.11-.563.045-.84-.114h-.001a2 2 0 0 1-.686-.668 2.05 2.05 0 0 1-.312-.897ZM72.256 78.424l-.001-.025v-4.994c0-.313.14-.584.416-.7.26-.108.565-.045.838.122.276.164.51.39.683.66v.001a2.1 2.1 0 0 1 .314.927v4.99c0 .315-.141.585-.417.7-.259.108-.563.047-.835-.113h-.002a2.06 2.06 0 0 1-.996-1.568ZM72.256 87.239l-.001-.025v-4.995c0-.313.14-.584.416-.699.26-.108.565-.045.838.122.276.163.51.39.683.66a2.1 2.1 0 0 1 .314.927v4.99c0 .316-.141.585-.417.7-.259.108-.563.048-.835-.112l-.002-.001a2.06 2.06 0 0 1-.996-1.567Z"
        fill="#FDFFD0"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="M98.711 50.59c-5.461 3.277-7.646-4.37-12.015-2.184l30.584-17.477c-3.823 2.184-1.092 9.83-4.369 12.015s-8.738 4.37-14.2 7.646"
        fill="#FDFFD0"
      />
      <path
        d="m86.696 48.406-.124-.218a.25.25 0 0 0 .236.441zm12.015 2.184-.129-.214zm14.2-7.646-.139-.208zm4.493-11.798a.25.25 0 1 0-.248-.434zM86.808 48.629c1.019-.51 1.9-.447 2.748-.11.87.344 1.692.968 2.596 1.594.888.615 1.846 1.222 2.94 1.456 1.109.236 2.334.084 3.748-.765l-.258-.428c-1.316.79-2.412.91-3.386.703-.987-.21-1.873-.763-2.76-1.377-.871-.603-1.757-1.276-2.695-1.648-.96-.38-1.991-.455-3.157.128zm12.032 2.175c2.721-1.632 5.443-2.994 7.902-4.223 2.453-1.226 4.653-2.326 6.308-3.429l-.278-.416c-1.622 1.082-3.791 2.167-6.254 3.398-2.456 1.228-5.195 2.598-7.936 4.242zm14.21-7.652c.893-.596 1.36-1.554 1.631-2.64.271-1.082.357-2.335.459-3.555.103-1.232.221-2.434.544-3.461.321-1.022.837-1.846 1.72-2.35l-.248-.434c-1.029.588-1.605 1.54-1.949 2.634-.342 1.088-.463 2.344-.565 3.57-.104 1.238-.188 2.442-.446 3.476-.258 1.03-.679 1.847-1.424 2.344zm4.106-12.44L86.572 48.188l.248.434 30.584-17.476z"
        fill="#1D1D1B"
      />
      <path
        clipRule="evenodd"
        d="M110.27 39.32c.201.353.078.802-.275 1.002l-11.913 6.776a.734.734 0 0 1-.726-1.277l11.913-6.775a.734.734 0 0 1 1.001.275"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        d="M104.481 116.984c-8.744 5.046-15.833.956-15.833-9.136s7.089-22.363 15.833-27.41c8.744-5.045 15.832-.954 15.832 9.137s-7.088 22.364-15.832 27.409Z"
        fill="#F1F78E"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="M104.481 116.984c-3.959 2.29-7.775 2.779-10.691 1.372.346-6.133 5.194-13.634 11.128-17.058 5.637-3.253 10.288-1.697 11.04 3.375-1.477 2.652-3.257 5.111-5.23 7.228s-4.099 3.847-6.247 5.083ZM104.916 97.95c-3.258 1.88-5.898.356-5.898-3.403s2.64-8.331 5.898-10.211 5.898-.356 5.898 3.404-2.641 8.33-5.898 10.21Z"
        fill="#fff"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="m93.166 76.902-9.27 5.352v10.704M114.487 121.325l9.271-5.352v-10.705M123.758 69.944V59.24l-9.271 5.352M83.896 128.283v10.704l9.27-5.352"
        stroke="#1D1D1B"
        strokeWidth={1.2}
      />
      <path
        d="M80.642 116.573v-9.624l5.136 1.984z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <mask
        height={34}
        id="phone-identification_svg__a"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
        width={41}
        x={47}
        y={102}
      >
        <path d="M50 135.5 48 125l34.5-22 5 13.5z" fill="#D9D9D9" stroke="#000" strokeWidth={0.5} />
      </mask>
      <g mask="url(#phone-identification_svg__a)">
        <path
          d="m46.474 131.375 33.817-19.524"
          stroke="#1D1D1B"
          strokeDasharray="3 3"
          strokeWidth={1.2}
        />
      </g>
    </svg>
  );
}
